import React from "react";
import { ProviderComposer } from "./ProviderComposer";
import { ContactProvider } from "./contact";
import { MenuProvider } from "./menu";

export function AppProviders({ children }) {
  return (
    <ProviderComposer providers={[ContactProvider, MenuProvider]}>
      {children}
    </ProviderComposer>
  );
}
